module.exports = __webpack_public_path__ + "static/media/slider-1.8b7150a7.png";